<template>
  <v-select
    id="loginType"
    v-model="selectedLoginType"
    class="login-type"
    :items="loginOptions"
  ></v-select>
</template>

<script>
export default {
  data() {
    return {
      selectedLoginType: 'username', // Default to username
      username: '',
      mobile: '',
      loginOptions: [
        { label: 'Username', value: 'username' },
        { label: 'Mobile Number', value: 'mobile' }
      ]
    }
  }
}
</script>
